import TranslationApi from "services/apis/translation"

export const saveLanguage = async (linkId = "", language = "") => {
    try {
        await TranslationApi.saveLanguage({ linkId, language })
    } catch (err) {
        console.log(err)
    }
}
